import Pill from "PFComponents/pill/pill";
import colors from "PFTheme/tokens/colors";
import { CustomValueImportRowState } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./import_data_table_page.module.scss";

const STATE_COLORS: Record<CustomValueImportRowState, string> = {
  // eslint-disable-next-line camelcase
  new_value: colors.paletteGreen0,
  // eslint-disable-next-line camelcase
  duplicated_value: colors.paletteEcharts6,
  merged: colors.paletteBlue0,
  blocked: colors.paletteBlack0,
  failed: colors.paletteRed1
};

type ImportStatePillProps = { state: CustomValueImportRowState };

export const ImportStatePill = ({ state }: ImportStatePillProps): JSX.Element => {
  const { t } = useTranslation("skillsManagement");

  return (
    <Pill style={{ background: STATE_COLORS[state] }} className={css.importStatePill}>
      {t(`header.modals.import.data.table.cells.statePill.${state}`)}
    </Pill>
  );
};
